/**
 * Created by jiachenpan on 16/11/18.
 */
//获取网址里的指定参数
export function GetQueryString(name) {
  let reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
  let r = window.location.search.substr(1).match(reg);
  if(r!=null)return  unescape(r[2]); return null;
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

// 格式化时间
export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/ig) != null) {
      len += 1
    } else { len += 0.5 }
  }
  return Math.floor(len)
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

export function param(json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined) return ''
    return encodeURIComponent(key) + '=' +
            encodeURIComponent(json[key])
  })).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach((property) => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

export function scrollTo(element, to, duration) {
  if (duration <= 0) return
  const difference = to - element.scrollTop
  const perTick = difference / duration * 10
  setTimeout(() => {
    //console.log(new Date())
    element.scrollTop = element.scrollTop + perTick
    if (element.scrollTop === to) return
    scrollTo(element, to, duration - 10)
  }, 10)
}

export function toggleClass(element, className) {
  if (!element || !className) {
    return
  }
  let classString = element.className
  const nameIndex = classString.indexOf(className)
  if (nameIndex === -1) {
    classString += '' + className
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length)
  }
  element.className = classString
}

export const pickerOptions = [
  {
    text: '今天',
    onClick(picker) {
      const end = new Date()
      const start = new Date(new Date().toDateString())
      end.setTime(start.getTime())
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近一周',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      picker.$emit('pick', [start, end])
    }
  }, {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date(new Date().toDateString())
      const start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
      picker.$emit('pick', [start, end])
    }
  }]

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDateString())
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function uniqueArr(arr) {
  return Array.from(new Set(arr))
}


export function getFileName(verCodeImg){
  let obj = verCodeImg.lastIndexOf("/");
  let fileName = verCodeImg.substr(obj+1)
  var pattern = /\.{1}[a-z]{1,}$/
  if (pattern.exec(fileName) !== null) {
    return (fileName.slice(0, pattern.exec(fileName).index))
  } else {
    return fileName
  }
}

export function coppyArray(coppyData){
  /*debugger*/
  return coppyData.map((e)=>{
    if(typeof e==='object'){
      return Object.assign({},e);
    }else{
      return e;
    }
  })
}

//数据克隆
export function clone(obj) {
  let buf;
  if (obj instanceof Array) {
    buf = [];
    let i = obj.length;
    while (i--) {
      buf[i] = clone(obj[i]);
    }
    return buf;
  }
  else if (obj instanceof Object) {
    buf = {};
    for (let k in obj) {
      buf[k] = clone(obj[k]);
    }
    return buf;
  }
  else {
    return obj;
  }
}

//数据克隆 // code //后台返回 rtnCode  type 成功或者失败， modelName 模块名称， operateType操作类型(0，查询1:添加,2:修改,3,删除,4:下载,5:导出,6:上传)
export function messageBox(code, type, modelName, operateType) {
  messageBox(rtnCode,0,"userMge",0)
  if(type == 0){
    this.$message({
      message: this.$t("organizationMge.delSuccess"),
      type: 'success',
      duration: 1000
    })
  }else {
    this.$message.error(this.$t("organizationMge.delError"));
  }

}

export function lastIndexOf(file) {
  let fileType = file.substring(file.lastIndexOf('.') + 1).toLowerCase()
  return fileType
}

//数组排序
export function sortNum(a,b){//排序方法
  return a-b;
}

//对象排序
export function sortKey(array,key){
  return array.sort(function(a,b){
    var x = a[key];
    var y = b[key];
    return ((x<y)?-1:(x>y)?1:0)
  })
}

//处理递归数据
export function recursiveData(data,pId) {
  const list = [];
  const queue = data;
  while (queue.length) {
    const node = queue.shift();
    if (node.children && node.children.length) {
      queue.push(...node.children);
    }

    delete node.children;
    // if (node[pId] !== null && node[pId]!== undefined) {
    //   node.checked = false
      list.push(node);
    // }
  }
  return list
}

export function  getFatherDataFun(getData,pid,getItemData) {
  for(var i = 0; i < getData.length; i++){
    if(getData[i].id == pid){
      getItemData.push(getData[i])
      if(getData[i].pid == '0' || getData[i].pid == undefined){
        break
      }else {
        getFatherDataFun(getData,getData[i].pid,getItemData)
      }
    }
  }
}


//时间排序
export function sortTime(timeArr,date) {
  timeArr.sort(function(a,b) {
    return Date.parse(b.updateDate.replace(/-/g,"/"))-Date.parse(a.updateDate.replace(/-/g,"/"));
  });
}

//实现数字+字母+中文的混合排序方法
export function arrMinNum(arr){
  var minNum = Infinity, index = -1,minVul = "";
  for (var i = 0; i < arr.length; i++) {
    if (typeof(arr[i]) == "string") {
      if (arr[i].charCodeAt()<minNum) {
        minNum = arr[i].charCodeAt();
        minVul = arr[i];
        index = i;
      }
    }else {
      if (arr[i]<minNum) {
        minNum = arr[i];
        minVul = arr[i]
        index = i;
      }
    }
  };
  return {"minNum":minVul,"index":index};
}
export function arrSortMinToMax(arr){
  var arrNew = [];
  var arrOld = arr.concat();
  for (var i = 0; i < arr.length; i++) {
    arrNew.push(arrMinNum(arrOld).minNum);
    arrOld.splice(arrMinNum(arrOld).index,1)
  };
  return (arrNew);
}
export function arrMaxNum(arr){
  var maxNum = -Infinity, index = -1,maxVul = "";
  for (var i = 0; i < arr.length; i++) {
    if (typeof(arr[i]) == "string") {
      if (arr[i].charCodeAt()>maxNum) {
        maxNum = arr[i].charCodeAt();
        maxVul = arr[i];
        index = i;
      }
    }else {
      if (arr[i]>maxNum) {
        maxNum = arr[i];
        maxVul = arr[i];
        index = i;
      }
    }
  };
  return {"maxNum":maxVul,"index":index};
}
export function arrSortMaxToMin(arr){
  var arrNew = [];
  var arrOld = arr.slice(0);
  for (var i = 0; i < arr.length; i++) {
    arrNew.push(arrMaxNum(arrOld).maxNum);
    arrOld.splice(arrMaxNum(arrOld).index,1);
  };
  return (arrNew);
}
/**
 *
 * @param d1 第一个时间
 * @param d2 第二个时间
 * 两个时间比大小
 * @constructor
 */
export function compareDate(d1, d2) {
  return ((new Date(d1)) > (new Date(d2)));
}

function SortLikeWin(v1, v2) {
  var a = v1.name;
  var b = v2.name;
  var reg = /[0-9]+/g;
  var lista = a.match(reg);
  var listb = b.match(reg);
  if (!lista || !listb) {
       return a.localeCompare(b);
   }
  for (var i = 0, minLen = Math.min(lista.length, listb.length) ; i < minLen; i++) {
     //数字所在位置序号
     var indexa = a.indexOf(lista[i]);
     var indexb = b.indexOf(listb[i]);
     //数字前面的前缀
     var prefixa = a.substring(0, indexa);
     var prefixb = b.substring(0, indexb);
     //数字的string
     var stra = lista[i];
     var strb = listb[i];
     //数字的值
     var numa = parseInt(stra);
     var numb = parseInt(strb);
     //如果数字的序号不等或前缀不等，属于前缀不同的情况，直接比较
     if (indexa != indexb || prefixa != prefixb) {
           return a.localeCompare(b);
       }
     else {
           //数字的string全等
         if (stra === strb) {
               //如果是最后一个数字，比较数字的后缀
             if (i == minLen - 1) {
                   return a.substring(indexa).localeCompare(b.substring(indexb));
               }
             //如果不是最后一个数字，则循环跳转到下一个数字，并去掉前面相同的部分
             else {
                   a = a.substring(indexa + stra.length);
                   b = b.substring(indexa + stra.length);
               }
           }
               //如果数字的string不全等，但值相等
         else if (numa == numb) {
    //直接比较数字前缀0的个数，多的更小
             return strb.lastIndexOf(numb + '') - stra.lastIndexOf(numa + '');
           }
        else {
               //如果数字不等，直接比较数字大小
             return numa - numb;
           }
       }
  }
}

/**
 *
 * @param name 获取url？后的值
 * @returns {string | null}
 */
export function getUrlKey (name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}

// 获取网址绝对路径
export function GetUrlRelativePath() {
  const url = document.location.toString();
  const arrUrl = url.split("//");

  const start = arrUrl[1].indexOf("/");
  let relUrl = arrUrl[1].substring(start);//stop省略，截取从start开始到结尾的所有字符

  if(relUrl.indexOf("?") != -1){
    relUrl = relUrl.split("?")[0];
  }
  return relUrl;
}



// WEBPACK FOOTER //
// ./src/utils/index.js